import BaseService from "./base.service";
const service = new BaseService("/projects/:id/notes")
export default service;